import type { IconGlyph } from '../icon';

/**
 * Tractie `close` glyph (medium, 24×24).
 *
 * Source: `@tractie/icons` v1.2.1 — `dist/jsx/m/close.jsx`.
 */
export const iconClose: IconGlyph = {
  name: 'close',
  path: 'M12.69 12h.02l5.65-5.65c.2-.2.2-.51 0-.71s-.51-.2-.71 0L12 11.29 6.35 5.64c-.2-.2-.51-.2-.71 0s-.2.51 0 .71L11.29 12l-5.65 5.65c-.2.2-.2.51 0 .71a.485.485 0 0 0 .7 0l5.65-5.65 5.65 5.65a.485.485 0 0 0 .7 0c.2-.2.2-.51 0-.71z',
};
